/**
 * Instant cart - loading state for remove (trash) button
 * Adds spinner feedback when removing items. On error/timeout, restores trash icon.
 */
(function () {
  const ERROR_TIMEOUT_MS = 8000;

  function init() {
    document.addEventListener('click', handleClick, true);
  }

  function handleClick(event) {
    const button = event.target.closest(
      'button[data-instant-action-type="adjust-line-item-quantity"]'
    );
    if (!button || !button.classList.contains('instant-remove-loading')) return;

    setLoading(button);

    // If API fails, Instant won't replace DOM. Remove loading state after timeout.
    const timeoutId = window.setTimeout(() => {
      if (document.contains(button)) {
        clearLoading(button);
      }
    }, ERROR_TIMEOUT_MS);

    // Clear timeout when DOM updates (success) - button is removed
    const observer = new MutationObserver(() => {
      if (!document.contains(button)) {
        observer.disconnect();
        window.clearTimeout(timeoutId);
      }
    });
    observer.observe(button.closest('[data-instant-type="root"]') || document.body, {
      childList: true,
      subtree: true,
    });
  }

  function setLoading(button) {
    if (!button.dataset.originalAriaLabel) {
      button.dataset.originalAriaLabel =
        button.getAttribute('aria-label') || 'Remove from cart';
    }
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-live', 'polite');
    button.setAttribute('aria-label', 'Removing item…');
  }

  function clearLoading(button) {
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-live');
    const original =
      button.dataset.originalAriaLabel || 'Remove from cart';
    button.setAttribute('aria-label', original);
    delete button.dataset.originalAriaLabel;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
